module.exports = __webpack_public_path__ + "img/NewVanIcon.56672bde.svg";